module.exports = __webpack_public_path__ + "img/DEGENER-logo-small.b043885c.svg";